export enum FollowUpStudyNotificationStatus {
	Notified = 1,
	NotNotified = 2,
}
